export interface ImcRange {
	/** Limite superior (exclusivo) da faixa; null na última faixa. */
	max: number | null
	type: string
	status: string
	range: string
}

/** Classificação do IMC segundo a OMS. */
export const IMC_CLASSIFICATION: ImcRange[] = [
	{
		max: 18.5,
		type: 'underweight',
		status: 'Abaixo do peso normal',
		range: 'Menor do que 18,5',
	},
	{ max: 25, type: 'normal', status: 'Peso normal', range: '18,5 - 24,9' },
	{
		max: 30,
		type: 'overweight',
		status: 'Excesso de peso',
		range: '25,0 - 29,9',
	},
	{
		max: 35,
		type: 'obese',
		status: 'Obesidade classe I',
		range: '30,0 - 34,9',
	},
	{
		max: 40,
		type: 'severe-obese',
		status: 'Obesidade classe II',
		range: '35,0 - 39,9',
	},
	{
		max: null,
		type: 'extreme-obese',
		status: 'Obesidade classe III',
		range: 'Maior ou igual a 40,0',
	},
]

export const IMC_CLASSIFICATION_SOURCE =
	'Classificação segundo a OMS a partir do IMC'

export function classifyImc(imc: number): ImcRange | undefined {
	if (!isFinite(imc)) return undefined
	return IMC_CLASSIFICATION.find(
		(item) => item.max === null || imc < item.max
	)
}
